import React, { useEffect, useState } from 'react';
import UniversalSearch from './UniversalSearch';
import { UniversalSearchActions } from "../../index";
import './universalSearch.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useHasRoles } from 'react-simple-rbac';
var UniversalSearchWrapper = function (props) {
    var isBasicLimited = useHasRoles(['BasicLimited']);
    var setSearchResult = props.setSearchResult, setSearchComplete = props.setSearchComplete, equipmentRedirectPath = props.equipmentRedirectPath;
    var dispatch = useDispatch();
    var universalSearch = useSelector(function (state) { return state; }).universalSearch;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var handleChange = function (e) {
        setIsOpen(true);
        dispatch(UniversalSearchActions.updateprefix(e.target.value));
    };
    useEffect(function () {
        setSearchComplete(false);
        if (universalSearch.prefix !== '' && isOpen) {
            if (universalSearch.prefix.length >= 3) {
                dispatch(UniversalSearchActions.fetchVehicleList(universalSearch.prefix));
                if (!isBasicLimited) {
                    dispatch(UniversalSearchActions.fetchCustomerList(universalSearch.prefix));
                }
                dispatch(UniversalSearchActions.fetchCommunicationList(universalSearch.prefix));
                setSearchComplete(false);
            }
        }
        if (universalSearch.prefix === '') {
            setIsOpen(false);
            setSearchResult('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [universalSearch.prefix]);
    return React.createElement(UniversalSearch, { onChange: handleChange, data: universalSearch, isOpen: isOpen, onBeforeRedirect: function () { setIsOpen(false); }, equipmentRedirectPath: equipmentRedirectPath });
};
export default UniversalSearchWrapper;
